import React from 'react';
import { useDispatch } from 'react-redux';
import { gql, useMutation } from '@apollo/client';
import { MenuItem } from '../../components/Menu';
import trashIcon from '../../icons/trash.svg';
import UIActions from '../../ui/UIActions';
import type {
  DeleteAnnotationMutation,
  DeleteAnnotationMutationVariables,
} from '../../graphql/generated/graphqlTypes';

const DELETE_ANNOTATION = gql`
  mutation deleteAnnotation($id: ID!) {
    deleteAnnotation(id: $id) {
      id
    }
  }
`;

interface AnnotationDeleteMenuItemProps {
  annotationId: string;
  onDeleted(): void;
}

const AnnotationDeleteMenuItem = ({
  annotationId,
  onDeleted,
}: AnnotationDeleteMenuItemProps) => {
  const dispatch = useDispatch();

  const [deleteAnnotation] = useMutation<
    DeleteAnnotationMutation,
    DeleteAnnotationMutationVariables
  >(DELETE_ANNOTATION);

  const onDelete = async () => {
    await deleteAnnotation({ variables: { id: annotationId } });
    onDeleted();
  };

  return (
    <MenuItem
      icon={trashIcon}
      danger
      onClick={() => {
        dispatch(
          UIActions.confirmModal({
            title: 'Delete Annotation?',
            message: 'This will delete the annotation.',
            confirmButtonText: 'Delete',
            onConfirm: onDelete,
          }),
        );
      }}
    >
      Delete annotation
    </MenuItem>
  );
};

export default AnnotationDeleteMenuItem;
